import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Color from 'color';

import config from '@/lib/config';
import { constructUrl } from '@/lib/utils';
import { createUseThemedStyles } from '@/hooks';
import { ReactComponent as HackettLogo } from '@/assets/logos/logo-hackett-connect-r-large.svg';
import { mediaQueries } from '@/jss';

const useStyles = createUseThemedStyles((theme) => ({
	header: {
		height: 80,
		display: 'flex',
		padding: '0 15px',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: theme.colors.primary,
		backgroundImage: `linear-gradient(-45deg, ${Color(theme.colors.primary)
			.darken(0.4)
			.hex()} 0%, ${Color(theme.colors.primary)
			.lighten(0.2)
			.desaturate(0.2)
			.hex()} 100%)`,
		[mediaQueries.lg]: {
			padding: '0 50px',
		},
	},
}));

interface HeaderNoAuthProps {
	showSignInButton?: boolean;
}

export const HeaderNoAuth = ({ showSignInButton }: HeaderNoAuthProps) => {
	const classes = useStyles();

	const handleSignInButtonClick = () => {
		window.location.href =
			config.HACKETT_ADVISORY_USE_REAL_AUTH === 'true'
				? constructUrl(config.HACKETT_ADVISORY_AUTH_UI_URL, {
						redirectUrl: encodeURIComponent(`${window.location.href}`),
						platform: 'hackett-connect',
				  })
				: '/sign-in';
	};

	return (
		<header className={classes.header}>
			<Link to="/">
				<HackettLogo className="d-flex text-white" width={316} height={29} />
			</Link>
			{showSignInButton && (
				<Button variant="secondary" size="sm" onClick={handleSignInButtonClick}>
					Sign In
				</Button>
			)}
		</header>
	);
};
